import { render, staticRenderFns } from "./Newfooter.vue?vue&type=template&id=b060213c&scoped=true"
import script from "./Newfooter.vue?vue&type=script&lang=js"
export * from "./Newfooter.vue?vue&type=script&lang=js"
import style0 from "./Newfooter.vue?vue&type=style&index=0&id=b060213c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b060213c",
  null
  
)

export default component.exports